import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vba92wh7ve: FaireBrandEntity = {
  token: "b_vba92wh7ve",
  type: "brand",
  name: "Beaten Path Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/34b446663499b078add55289e05041c795f0cb95911ea69bd14910cd2737e9ac.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/423c56c54bdb82b720215b4b123014f526d1fd2af8103dca9128f7f5db2d5c4b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/34b446663499b078add55289e05041c795f0cb95911ea69bd14910cd2737e9ac.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/423c56c54bdb82b720215b4b123014f526d1fd2af8103dca9128f7f5db2d5c4b.jpeg",
  location: "Greenville, SC, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Beaten Path Co exists to reconnect all people with nature, no matter their outdoor interests or skill level. Our aim is to inspire a shared love for the outdoors, striving for a world where nature's harmony leads us closer to global peace. We believe a healthy planet needs a healthy host. We donate 100% of profits from our Be The Change products to a new organization every season. We focus on minimizing our environmental impact and using eco-friendly clothing/packaging and ethical manufacturers. Creating a better tomorrow.\n\nWhat does being human mean to you? To us, it's about genuine imperfections and endless curiosity. Allowing ourselves to mess up as we grow and look to others for community and support when we need it.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:51.177Z",
    importedBy: "entity-db-cli",
  },
};
